import React, { Component, Fragment } from 'react';
import map from 'lodash.map';
import orderBy from 'lodash.orderby';
import { getActChild } from '../../../helpers/ActChildren';
import { ActComments } from './ActComments';

export class ActElement extends Component {
	render() {
		const {
			childrens,
			classNameCont = '',
			showComment,
			canCommentAndSetOpinion,
			addCommentOpinion,
			removeCommentOpinion,
			opinionExecuting,
			projectId,
			agreementAccepted = false,
			agreementAcceptedRequired = false,
			scrollToAgreement = Function.prototype,
			userId,
			showOpinion = false,
			isCommentAdding = false,
			...restProps
		} = this.props;

		return (
			<ActComments
				showComment={showComment}
				saveComment={(comment) => this.props.saveComment(comment)}
				canCommentAndSetOpinion={canCommentAndSetOpinion}
				addCommentOpinion={addCommentOpinion}
				removeCommentOpinion={removeCommentOpinion}
				projectId={projectId}
				opinionExecuting={this.props.opinionExecuting}
				agreementAccepted={agreementAccepted}
				agreementAcceptedRequired={agreementAcceptedRequired}
				scrollToAgreement={scrollToAgreement}
				userId={userId}
				classNameCont={`act__element${classNameCont ? ` ${classNameCont}` : ''}`}
				showOpinion={showOpinion}
				isCommentAdding={isCommentAdding}
				{...restProps}
			>
				{map(orderBy(childrens, (c) => c.order), (c) =>
					getActChild(c, {
						canCommentAndSetOpinion,
						addCommentOpinion,
						removeCommentOpinion,
						projectId,
						showComment,
						opinionExecuting,
						agreementAccepted,
						agreementAcceptedRequired,
						scrollToAgreement,
						userId,
						saveComment: (comment) => this.props.saveComment(comment),
						showOpinion,
						isCommentAdding
					})
				)}
			</ActComments>
		);
	}
}
